import { render } from "./DocumentReferenceEditWidget.vue?vue&type=template&id=dd50ffbe&ts=true"
import script from "./DocumentReferenceEditWidget.ts?vue&type=script&lang=ts&external"
export * from "./DocumentReferenceEditWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__